import { AppErrorBoundary } from '@/app/ErrorBoundary';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { AppProviders } from '@/app/providers';
import { router } from '@/app/router';
import { applyThemeAttributes, readLocalThemePrefs } from '@/lib/theme';
import './styles/globals.css';

// Before React mounts, so first paint already has the right palette/glow/glass/motion —
// no flash of the default theme (docs/03-architecture.md §4.5).
applyThemeAttributes(readLocalThemePrefs());

// Dev-only hook for the ui-check harness's self-test (docs/03 §7.1, apps/web/ui-check/README.md):
// visiting any route with ?ui-check-inject-error=1 logs a console error, so the harness's own
// console-error detection can be proven to actually fail on one. No-ops in production builds.
if (
  import.meta.env.DEV &&
  new URLSearchParams(window.location.search).has('ui-check-inject-error')
) {
  console.error('[ui-check] injected console error for self-test');
}

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html');

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </AppErrorBoundary>
  </StrictMode>,
);
